import React, { useState } from "react";
import PageHeader from "../../components/ui/PageHeader";
import Listing from "../../components/ui/Listing";
import { destroy, get } from "../../server";
import {
	ADMIN_EVENTS_LISTING_SEARCH,
	ADMIN_EVENT_DELETE,
	ADMIN_PAST_EVENTS_LISTING,
} from "../../data/constants/apiRoutes";
import queryNames from "../../data/constants/queryNames";
import { Box, IconButton, Stack, Tooltip, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import BoxModal from "../../components/Modals/BoxModal";
import { useMutation, useQueryClient } from "react-query";
import { enqueueSnackbar } from "notistack";
import { ReactComponent as Edit } from "../../assets/svg/Edit.svg";
import { ReactComponent as Delete } from "../../assets/svg/Delete.svg";

const PastEvents = () => {
	const navigate = useNavigate();

	const [search, setSearch] = useState("");
	const [finalSearch, setFinalSearch] = useState("");
	const [isSearch, setIsSearch] = useState(false);

	const [modal, setModal] = useState(false);
	const [eventId, setEventId] = useState("");

	const client = useQueryClient();

	const columns = [
		{
			field: "event_name",
			headerName: "Event Name",
			sortable: false,
			flex: 1,
			renderCell: (params) => {
				return (
					<Box
						component="div"
						style={{
							cursor: "pointer",
						}}
					>
						{params.row.event_name}
					</Box>
				);
			},
		},
		{
			field: "is_featured",
			headerName: "Status",
			sortable: false,
			width: 150,
			renderCell: (params) => {
				return (
					<Box
						sx={{
							// bgcolor:
							// statusColors[params.row.subscription_status]?.bgcolor,
							// color: statusColors[params.row.subscription_status]?.color,
							bgcolor: params.row.is_featured ? "#E3F2F3" : "#FCF9EC",
							color: params.row.is_featured ? "#03989E" : "#F2D048",
							textTransform: "capitalize",
							width: "auto",
							px: 1,
							height: 30,
							fontSize: 12,
							lineHeight: "30px",
							textAlign: "center",
							borderRadius: "4px",
						}}
					>
						{params.row.is_featured ? "Featured" : "Not-Featured"}
					</Box>
				);
			},
		},
		{
			field: "company_name",
			headerName: "Company Name",
			sortable: false,
			flex: 1,
		},
		{
			field: "address",
			headerName: "Address",
			sortable: false,
			flex: 1,
		},
		{
			field: "event_status",
			headerName: "Event Status",
			sortable: false,
			width: 180,
			renderCell: (params) => {
				return (
					<Typography component="label" textTransform="capitalize">
						{params.row.event_status}
					</Typography>
				);
			},
		},
		{
			field: "start_time",
			headerName: "Start Time",
			sortable: false,
			width: 180,
		},
		{
			field: "end_time",
			headerName: "End Time",
			sortable: false,
			width: 180,
		},
		{
			field: "action",
			headerName: "Action",
			sortable: false,
			width: 100,
			renderCell: (params) => {
				return (
					<Stack direction="row">
						<Tooltip title="Edit" arrow placement="top">
							<IconButton
								onClick={() => navigate(`/events/edit/${params.row.id}`)}
							>
								<Edit />
							</IconButton>
						</Tooltip>
						<Tooltip title="Delete" arrow placement="top">
							<IconButton
								onClick={() => {
									setEventId(params.row.id);
									setModal("delete");
								}}
							>
								<Delete sx={{ color: "red" }} />
							</IconButton>
						</Tooltip>
					</Stack>
				);
			},
		},
	];

	const fetchEvents = async (pageNo, limit, searchParam, isSearchParam) => {
		let url;

		if (isSearchParam === false) {
			url = new URL(ADMIN_PAST_EVENTS_LISTING);
		} else if (isSearchParam && searchParam.length) {
			url = new URL(ADMIN_EVENTS_LISTING_SEARCH);
			url.searchParams.append("search", searchParam);
			url.searchParams.append("type", "past");
		}

		url.searchParams.append("page", pageNo + 1);
		url.searchParams.append("limit", limit);

		return await get(url.toString());
	};

	const handleCellClick = (data) => {
		if (data?.field === "event_name") {
			navigate(`/events/detail/${data.id}`);
		}
	};

	const handleSearchClick = () => {
		if (search.length) {
			setIsSearch(true);
			setFinalSearch(search);
		}
	};

	const handleCancleSearch = () => {
		setIsSearch(false);
		setSearch("");
	};

	const handleClose = () => {
		setModal(false);
		setEventId(null);
	};

	const handleDelete = async () => {
		const { status, message } = await destroy(
			`${ADMIN_EVENT_DELETE}/${eventId}`
		);

		if (status) {
			enqueueSnackbar(message, { variant: "success" });
			handleClose();
			handleInvalidate();
		} else {
			enqueueSnackbar(message, { variant: "error" });
		}
	};

	const mutation = useMutation(handleDelete);

	const handleConfirm = () => {
		mutation.mutate();
	};

	const handleInvalidate = () => {
		client.invalidateQueries(`p${queryNames.EVENTS}`);
	};

	return (
		<>
			<PageHeader
				title="Past Events"
				placeholder="Search Events"
				searchInput={true}
				search={search}
				setSearch={setSearch}
				isSearch={isSearch}
				handleCancleSearch={handleCancleSearch}
				handleSearchClick={handleSearchClick}
			/>

			<Listing
				columns={columns}
				queryName={`p${queryNames.EVENTS}`}
				fetchRecords={fetchEvents}
				handleCellClick={handleCellClick}
				search={finalSearch}
				isSearch={isSearch}
			/>

			<BoxModal
				header="Are you sure?"
				title={"Do you really want to delete this event"}
				open={modal === "delete"}
				handleClose={handleClose}
				handleConfirm={handleConfirm}
				confirmButton="Delete"
				confirmButtonColor="#E53935"
				isLoading={mutation.isLoading}
			/>
		</>
	);
};

export default PastEvents;
